import React, { Component } from 'react';

import './ResponseManage.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames'

import '../common.css'
import '../fonts/font.css'

// Components
import ReferenceLists from './ReferenceLists';

import { faTruckLoading } from '@fortawesome/free-solid-svg-icons';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
import Tab from '../Tab';
import ComponentPicker from './Pickers/ComponentPicker';
import ElementPicker from './Pickers/ElementPicker';
import DnDContext from '../DnDContext';
import MessageBoardContainer from '../MessageManage/MessageBoardContainer';
import ComponentTrash from './ComponentTrash';
import ConditionListContainer from './ConditionList/ConditionListContainer';
import { getWording } from '../Wording';
import deleteResponse from '../DeleteResponse'
import { setApiServerHost, setImgServerHost } from '../common/APIServerSettings';
import MessageActions from '../MessageManage/MessageActions/MessageActions'
import { DnD_element_type } from '../common/ConstantValues';
import { onDropComponent } from '../MessageManage/DropComponentCommonFunctions';

const DEFAULT_TITLE = '리스폰스 관리'

// const compareMessages = (messages, prevMessages) => {
//   const messagesLength = messages ? messages.length : 0
//   const prevMessagesLength = prevMessages ? prevMessages.length : 0
  
//   if (messagesLength === prevMessagesLength) {
    
//   }
// }
// const loop = (elem, prevElem) => {
  
// }

/**
 * ResponseManage
 */
class ResponseManage extends Component { 
  static defaultProps = {
    /**
     * Callbacks
     */
    onMsgChanges: () => {
      console.warn('ResponseManage - props.onMsgChanges is not defined')
    },
    /**
     * ConditionList
     */
    requestId: -1,
    conditionActions: {
      addCondition: () => {
        console.warn('ResponseManage - props.conditionActions.addCondition is not defined')
      },
      updateCondition: () => {
        console.warn('ResponseManage - props.conditionActions.updateCondition is not defined')
      },
      deleteCondition: () => {
        console.warn('ResponseManage - props.conditionActions.deleteCondition is not defined')
      },
    },
    /**
     * MessageBoard
     */
    currentEditMessage: undefined,
    /**
     * SliderView
     */
    currentEditSlidePage: undefined,
    /**
     * ReferenceList
     */
    // referenceListActions: {
    //   updateEntityList: () => {
    //     console.warn('ResponseManage - props.referenceListActions.updateEntityList is not defined')
    //   },
    //   changeEntityTypeSelection: () => {
    //     console.warn('ResponseManage - props.referenceListActions.changeEntityTypeSelection is not defined')
    //   },
    //   updateEntityDetail: () => {
    //     console.warn('ResponseManage - props.referenceListActions.updateEntityDetail is not defined')
    //   },
    //   setCreateEntityModal: () => {
    //     console.warn('ResponseManage - props.referenceListActions.setCreateEntityModal is not defined')
    //   },
    //   deleteEntity: () => {
    //     console.warn('ResponseManage - props.referenceListActions.deleteEntity is not defined')
    //   },
    //   setEditTargetEntity: () => {
    //     console.warn('ResponseManage - props.referenceListActions.setEditTargetEntity is not defined')
    //   },
    // },
    referenceListProps: {
      selectedEntityType : -1,
      typeEntityObject : {},
      topicId : -1,
    },

    /**
     * common
     */
    isDragging: false,
    messageActions: {
      addComponent: MessageActions.ADD_COMPONENT,
      deleteMessage: MessageActions.DELETE_MESSAGE,
      updateComponentIndexPos: MessageActions.UPDATE_COMPONENT_INDEX_POS,
      updateDepthCompIndexPos: MessageActions.UPDATE_DEPTH_COMPONENT_INDEX_POS,
      addMessage: MessageActions.ADD_MESSAGE,
      updateMessageIndex: MessageActions.UPDATE_MESSAGE_INDEX,
      updateSlidePageToMessage: MessageActions.UPDATE_SLIDE_PAGE_TO_MESSAGE, 
      deleteComponent: MessageActions.DELETE_COMPONENT,
      updateRow: MessageActions.UPDATE_ROW,
      copyComponent: MessageActions.COPY_COMPONENT,
      updateComponent: MessageActions.UPDATE_COMPONENT,
      setIsDragging: () => {
        console.warn('ResponseManage - props.messageActions.setIsDragging is not defined')
      },
      setMsgChanges: () => {
        console.warn('ResponseManage - props.messageActions.setMsgChanges is not defined')
      },
      setCurrentEditSlidePage: () => {
        console.warn('ResponseManage - props.messageActions.setCurrentEditSlidePage is not defined')
      },
      setIndexForSlidePage: () => {
        console.warn('ResponseManage - props.messageActions.setIndexForSlidePage is not defined')
      },
    },
    // messageActions: {
    //   addComponent: () => {
    //     console.warn('ResponseManage - props.messageActions.addComponent is not defined')
    //   },
    //   deleteMessage: () => {
    //     console.warn('ResponseManage - props.messageActions.deleteMessage is not defined')
    //   },
    //   updateComponentIndexPos: () => {
    //     console.warn('ResponseManage - props.messageActions.updateComponentIndexPos is not defined')
    //   },
    //   updateDepthCompIndexPos: () => {
    //     console.warn('ResponseManage - props.messageActions.updateDepthCompIndexPos is not defined')
    //   },
    //   addMessage: () => {
    //     console.warn('ResponseManage - props.messageActions.addMessage is not defined')
    //   },
    //   updateMessageIndex: () => {
    //     console.warn('ResponseManage - props.messageActions.updateMessageIndex is not defined')
    //   },
    //   updateSlidePageToMessage: () => {
    //     console.warn('ResponseManage - props.messageActions.updateSlidePageToMessage is not defined')
    //   }, 
    //   deleteComponent: () => {
    //     console.warn('ResponseManage - props.messageActions.deleteComponent is not defined')
    //   },
    //   updateRow: () => {
    //     console.warn('ResponseManage - props.messageActions.updateRow is not defined')
    //   },
    //   copyComponent: () => {
    //     console.warn('ResponseManage - props.messageActions.copyComponent is not defined')
    //   },
    //   updateComponent: () => {
    //     console.warn('ResponseManage - props.messageActions.updateComponent is not defined')
    //   },
    //   setIsDragging: () => {
    //     console.warn('ResponseManage - props.messageActions.setIsDragging is not defined')
    //   },
    //   setMsgChanges: () => {
    //     console.warn('ResponseManage - props.messageActions.setMsgChanges is not defined')
    //   },
    //   setCurrentEditSlidePage: () => {
    //     console.warn('ResponseManage - props.messageActions.setCurrentEditSlidePage is not defined')
    //   },
    //   setIndexForSlidePage: () => {
    //     console.warn('ResponseManage - props.messageActions.setIndexForSlidePage is not defined')
    //   },
    // },
    editing_message_index: -1,
    editing_row_index: -1,
    editing_slide_page_index: -1,
    topicUpdateID: -1,
    editCurrentResponse: undefined,

    /**
     * UI
     */
    autoSave: undefined, 
    msgChanges: undefined,
    msgUpdating: undefined,
    clickASBtn: () => {
      console.warn('ResponseManage - props.clickASBtn is not defined')
    },
    clickSaveBtn: () => {
      console.warn('ResponseManage - props.clickSaveBtn is not defined')
    },
    setShowResponseManage: () => {
      console.warn('ResponseManage - props.setShowResponseManage is not defined')
    },
    responseChanged: () => {
      console.warn('ResponseManage - props.responseChanged is not defined')
    },
    deleteThisResponse: () => {
      console.warn('ResponseManage - props.deleteThisResponse is not defined')
    },
    toggleIsEditResponseMode: () => {
      console.warn('ResponseManage - props.toggleIsEditResponseMode is not defined')
    },
    onDropDeleteArea: () => {
      console.warn('ResponseManage - props.onDropDeleteArea is not defined')
    },
    onComplete: undefined,
    noHeader: undefined,
    showTabs: {
      GLOBAL_ENTITY: true,
      TOPIC_ENTITY: false,
      MODULE: false,
      AGENT: false,
    },
    title: DEFAULT_TITLE,
    hideUIs: {
      ElementPicker: false,
      ComponentPicker: false,
      ComponentTrash: false,
      Settings: false,
      MessageBoard: false,
      RefList: false,
      RemoveResponseBtn: false,
    },

    /**
     * Settings
     */
    apiHost: null,
  }

  /**
   * State definition
   */
  state = {
    messages: null,
    currentEditSlidePage: null,
    // editTargetState: {
    //   currentEditMessage: null,
    //   currentEditSlidePage: null,
    // },
    isDragging: false,
    /**
     * Indexes
     */
    msgIndex: null,
    rowIndex: null,
    SPIndex: null,

    /**
     * States
     */
    msgChanges: false,
  }
  
  componentDidMount() {
    const { apiHost, imgHost } = this.props
    if (apiHost) {
      setApiServerHost(apiHost)
    }
    if (imgHost) {
      setImgServerHost(imgHost)
    }
  }

  /**
   * Trigging when showResponseManage turn to false (Rendering condition)
   */
  componentWillUnmount(){
    console.log('ResponseManage - unmount')
    const { msgChanges, msgUpdating, setShowResponseManage, toggleIsEditResponseMode } = this.props
    if (msgUpdating) {
      window.alert(getWording('RESPONSE_MANAGE_PANEL_WAIT_WARN'))
      setShowResponseManage(true)
      return
    }
    if (msgChanges) {
      const changes_confirm = window.confirm(getWording('RESPONSE_MANAGE_PANEL_EXIT_WARN'))
      if (!changes_confirm) {
        setShowResponseManage(true)
        return
      }

      // toggleIsEditResponseMode(false)
    }
    toggleIsEditResponseMode(false)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { editCurrentResponse } = prevProps
    const { messages } = this.state
    const _editCurrentResponse = this.props.editCurrentResponse
    
    console.log('messages :>> ', messages);
    if (messages) {
      const { onMsgChanges } = this.props
      onMsgChanges(messages)
    }
    
    // if (!_editCurrentResponse) {
    //   return true
    // }
    // Disable logic when no data each variable
    if (!editCurrentResponse || !_editCurrentResponse) {
      return true
    }
    const editCurrentResponseId = editCurrentResponse.id 
    const _editCurrentResponseId = _editCurrentResponse.id

    // Initialize data for related 
    if (editCurrentResponseId !== _editCurrentResponseId) {
      const { responseChanged } = this.props
      responseChanged()
    }
  }

  addComponent = (arg) => {
    const { messages, currentEditSlidePage } = this.state
    const editTargetState = {
      currentEditMessage: messages,
      currentEditSlidePage: currentEditSlidePage,
    }
    const { type } = arg
    const { editState, result } = MessageActions.ADD_COMPONENT(editTargetState, arg, type)
    if (editState === 'SLIDE_PAGE') {
      this.setState({
        currentEditSlidePage: result,
      })
    } else {
      this.setState({messages: result})
    }
  }
  deleteMessage = (indexToDel) => {
    const { messages } = this.state
    
    const result = MessageActions.DELETE_MESSAGE(messages, indexToDel)
    this.setState({messages: result}) 
  }
  updateComponentIndexPos = (arg) => {
    const { messages, currentEditSlidePage } = this.state
    const editTargetState = {
      currentEditMessage: messages,
      currentEditSlidePage: currentEditSlidePage,
    }
    const { editState, result } = MessageActions.UPDATE_COMPONENT_INDEX_POS(editTargetState, arg)
    if (editState === 'SLIDE_PAGE') {
      this.setState({
        currentEditSlidePage: result,
      })
    } else {
      this.setState({messages: result})
    }
  }
  updateDepthCompIndexPos = (arg) => {
    const { messages, currentEditSlidePage } = this.state
    const editTargetState = {
      currentEditMessage: messages,
      currentEditSlidePage: currentEditSlidePage,
    }
    // This editTargetState but, returns only messagesData(not slide page)
    this.setState({messages: MessageActions.UPDATE_DEPTH_COMPONENT_INDEX_POS(editTargetState, arg)})
  }
  addMessage = (arg) => {
    const { messages } = this.state
    
    this.setState({messages: MessageActions.ADD_MESSAGE(messages, arg)})
  }
  updateMessageIndex = (arg) => {
    const { messages } = this.state
    
    this.setState({messages: MessageActions.UPDATE_MESSAGE_INDEX(messages, arg)})
  }
  // const setCurrentEditSlidePage = (messages, indexes) => {

  // }
  updateSlidePageToMessage = (arg) => {
    const { messages, currentEditSlidePage } = this.state
    const editTargetState = {
      currentEditMessage: messages,
      currentEditSlidePage: currentEditSlidePage,
    }
    // This editTargetState but, returns only messagesData(not slide page)
    this.setState({messages: MessageActions.UPDATE_SLIDE_PAGE_TO_MESSAGE(editTargetState, arg)}) 
  }
  deleteComponent = (arg) => {
    const { messages, currentEditSlidePage } = this.state
    const editTargetState = {
      currentEditMessage: messages,
      currentEditSlidePage: currentEditSlidePage,
    }
    const { editState, result } =  MessageActions.DELETE_COMPONENT(editTargetState, arg)
    if (editState === 'SLIDE_PAGE') {
      this.setState({
        currentEditSlidePage: result,
      })
    } else {
      this.setState({messages: result})
    }
  }
  // const setIsDragging = () => {

  // }
  updateRow = (arg) => {
    const { messages, currentEditSlidePage } = this.state
    const editTargetState = {
      currentEditMessage: messages,
      currentEditSlidePage: currentEditSlidePage,
    }
    const { row } = arg
    const { editState, result } = MessageActions.UPDATE_ROW(editTargetState, arg, row)
    if (editState === 'SLIDE_PAGE') {
      this.setState({
        currentEditSlidePage: result,
      })
    } else {
      this.setState({
        messages: result,
      })
    }
  }
  copyComponent = (arg) => {
    const { messages } = this.state
    
    this.setState({
      messages: MessageActions.COPY_COMPONENT(messages, arg)
    }) 
  }
  // const setIndex = (messages, indexes) => {
  //   return MessageActions.UPDATE_MESSAGE_INDEX(messages, indexes)
  // }
  updateComponent = (arg) => {
    console.log('arg :>> ', arg);
    const { messages, currentEditSlidePage } = this.state
    const editTargetState = {
      currentEditMessage: messages,
      currentEditSlidePage: currentEditSlidePage,
    }
    const { updateInfo, indexInfo } = arg
    const { editState, result } = MessageActions.UPDATE_COMPONENT(editTargetState, indexInfo, updateInfo)
    if (editState === 'SLIDE_PAGE') {
      this.setState({
        currentEditSlidePage: result,
      })
    } else {
      this.setState({
        messages: result,
      })
    }
  }

  deleteDepthComponent = (arg) => {
    const { messages } = this.state
    
    this.setState({
      messages: MessageActions.DELETE_DEPTH_COMPONENT(messages, arg),
    })
  }

  _setIsDragging = ({dragging}) => {
    this.setState({
      isDragging: dragging,
    })
  }

  setEditingIndexes = (e) => {
    if (!e) {
      this.setState({
        msgIndex: null,
        rowIndex: null,
        SPIndex: null,
      })
    } else {
      const {message_index, row_index, slide_page_index} = e
      if (message_index || message_index === 0) {
        this.setState({
          msgIndex: message_index,
        })
      } else { this.setState({msgIndex: null}) }
      if (row_index || row_index === 0) {
        this.setState({rowIndex: row_index})
      } else { this.setState({rowIndex: null}) }
      if (slide_page_index || slide_page_index === 0) {
        this.setState({
          SPIndex: slide_page_index,
        })
      } else { this.setState({SPIndex: null}) }
    }
  }

  onDropDeleteArea = (e) => {
    const { isDragging, SPIndex } = this.state
    // this.props.setMsgChanges(true)
    if (isDragging) {
      this.setState({
        isDragging: false,
      })
    }
    const { rowIndexDetail, type, prefix_type } = e
    e = {...e,
      row_index_detail: rowIndexDetail,
      slide_page_index: SPIndex,
    }

    // Logic for depth components
    if (type === DnD_element_type.COMPONENT.NORMAL.GROUP && prefix_type === "NORMAL") {
      onDropComponent(this.deleteDepthComponent, e)
      return
    }

    onDropComponent(this.deleteComponent, e, null, null, null)
  }
  deleteDepthComponent = (arg) => {
    const { messages } = this.state
    this.setState({
      messages: MessageActions.DELETE_DEPTH_COMPONENT(messages, arg)
    })
  }
  deleteComponent = (arg) => {
    const { messages, currentEditSlidePage } = this.state
    const editTargetState = {
      currentEditMessage: messages,
      currentEditSlidePage: currentEditSlidePage,
    }
    const { editState, result } =  MessageActions.DELETE_COMPONENT(editTargetState, arg)
    if (editState === 'SLIDE_PAGE') {
      this.setState({
        currentEditSlidePage: result,
      })
    } else {
      this.setState({
        messages: result,
      })
    }
  }

  /**
   * Wrapped messageActions Object
   */
  _messageActions = {
    addComponent: this.addComponent,
    deleteMessage: this.deleteMessage,
    updateComponentIndexPos: this.updateComponentIndexPos,
    updateDepthCompIndexPos: this.updateDepthCompIndexPos,
    addMessage: this.addMessage,
    updateMessageIndex: this.updateMessageIndex,
    updateSlidePageToMessage: this.updateSlidePageToMessage, 
    deleteComponent: this.deleteComponent,
    updateRow: this.updateRow,
    copyComponent: this.copyComponent,
    updateComponent: this.updateComponent,
    setIndexForSlidePage: this.setEditingIndexes, // setIndex
    setIsDragging: this._setIsDragging,
    setCurrentEditSlidePage: value => {console.log('value :', value); this.setState({currentEditSlidePage: value})},
    setMsgChanges: e => {
      this.setState({
        msgChanges: e,
      })
    }
  }

  /**
   * '이 리스폰스 삭제' button `onClick` event handling
   */
  handleClickDeleteButton = (e) => {
    const { deleteThisResponse } = this.props
    if (window.confirm('삭제한 후 되돌릴 수 없습니다. 삭제하시겠습니까?')) {
      const { editCurrentResponse } = this.props
      const { updateID } = editCurrentResponse
      deleteResponse(this.callBackDeleteResponse, updateID)
    }
  }

  // 삭제 요청 콜백
  callBackDeleteResponse = (response) => {
    const { data } = response;
    const { statusCode } = data;

    switch(statusCode) {
      case 200:
      const { deleteThisResponse } = this.props;
      deleteThisResponse();
      break;

      case 403:
        alert("리스폰스를 삭제하지 못했습니다.");
      break;

      case 500:
        alert("서버에서 에러가 발생하였습니다.");
      break;

      default:
        alert('요청을 원활하게 수행하지 못하였습니다.')
    }
  }

  render() {
    const { toggleIsEditResponseMode } = this.props;
    /**
     * UI
     */
    const { 
      autoSave, 
      msgUpdating, 
      msgChanges, 
      editCurrentResponse, 
      requestId,  
      onComplete,
      noHeader,
      showTabs,
    } = this.props

    // indexes
    // const { editingIndexes } = this.props
    const { editing_message_index, editing_row_index, editing_slide_page_index } = this.props

    /**
     * MessageBoard
     */
    const { messages } = this.state
    /**
     * SliderView
     */
    const { currentEditSlidePage } = this.state
    
    /**
     * Edit target
     */
    // const editTargetState = {
    //   currentEditMessage: messages,
    //   currentEditSlidePage: editCurrentSlidePage,
    // }

    /**
     * ConditionList
     */
    const { conditionActions } = this.props
    const { conditions } = editCurrentResponse ? editCurrentResponse : {}
    const responseUId = editCurrentResponse ? editCurrentResponse.updateID : null
    const conditionListProps = {
      conditions: conditions,
      responseUId: responseUId,
      requestId: requestId,
      conditionActions: conditionActions,
    }

    /**
     * common
     */
    const { isDragging } = this.props

    const asBtnClassname = classnames('custom-btn toggle-btn as-btn', {
      'activated': autoSave && autoSave !== null,
      'de-activated': !autoSave && autoSave !== null,
    })

    const statusMsgState = (() => {
      const init_msg = ''
      if (msgUpdating === null && msgChanges === null) {
        return 'AS_STATUS_MSG_INIT'
      }

      if (autoSave) {
        if (msgUpdating) {
          return 'AS_STATUS_MSG_SAVING'
        } 
        return 'AS_STATUS_MSG_ALL_SAVED'
      } else {
        if (msgUpdating) {
          return 'AS_STATUS_MSG_SAVING'
        }
        if (msgChanges) {
          return 'AS_STATUS_MSG_SAVE'
        }
        return 'AS_STATUS_MSG_ALL_SAVED'
      }
    })

    /**
     * Local flags
     */
    const { hideUIs } = this.props
    const show_tab_settings = hideUIs ? !hideUIs.Settings : true
    const show_delete_response_btn = hideUIs ? !hideUIs.RemoveResponseBtn : true
    // This flag also meaning run related functions to auto save
    const show_AS = !onComplete ? true : false
    const show_ref_list = !onComplete ? true : false
    const show_exit_btn = !onComplete ? true : false
    const show_header = !noHeader ? true : false

    // const messageActions = {
    //   ...this.props.messageActions,
    //   // Intercept when onComplete is exist
    //   setMsgChanges: (value) => {
    //     if (!show_AS) {
    //       return 
    //     }
    //     this.props.messageActions.setMsgChanges(value)
    //   }
    // }

    /**
     * Dynamic classnames
     */
    const modalBodyClassnames = classnames('modal-body', {
      'no-header': !show_header,
    })

    const wrapperClassnames = classnames('wrapper', {
      'no-header': !show_header,
    })

    return (
      // <div class="white-space">
        <div className="response-generation-modal">
          <div className={wrapperClassnames}>
            {
              show_header && (
                <div className="modal-custom-header">
                  <p className="title" > {this.props.title} </p>
                  {
                    !show_AS && (
                      <button className='custom-btn complete-btn'
                        onClick={onComplete}>
                        편집 완료
                      </button>
                    )
                  }
                  {
                    show_AS && (
                      <React.Fragment>
                        <button className={asBtnClassname} onClick={(e) => {this.props.clickASBtn()}}> 자동 저장 </button>
                        <p className={`save-state-msg ${statusMsgState === 'AS_STATUS_MSG_INIT' ? 'activated' : ''}`}> {getWording(statusMsgState)} </p>
                        <p className={`save-state-msg ${statusMsgState === 'AS_STATUS_MSG_SAVING' ? 'activated' : ''}`}> {getWording(statusMsgState)} </p>
                        <p className={`save-state-msg ${statusMsgState === 'AS_STATUS_MSG_ALL_SAVED' ? 'activated' : ''}`}> {getWording(statusMsgState)} </p>
                        <p className={`save-state-msg clickable ${statusMsgState === 'AS_STATUS_MSG_SAVE' ? 'activated' : ''}`} onClick={this.props.clickSaveBtn}> {getWording(statusMsgState)} </p>
                      </React.Fragment>
                    )
                  }
                  {
                    show_exit_btn && (
                      <button 
                        className="back-btn"
                        onClick={toggleIsEditResponseMode}
                        title="나가기">
                          <FontAwesomeIcon className="back-btn-icon" icon="times"/>
                      </button>
                    )
                  }
                </div>
              )
            }
            <div className={modalBodyClassnames}>
              <div class="content-col">
                <Tab title="요소">
                  <DnDContext>
                    <ElementPicker />
                  </DnDContext>
                </Tab>
                <Tab title="컴포넌트">
                  <ComponentPicker />
                </Tab>
                <Tab title="삭제">
                  <ComponentTrash onDrop={this.onDropDeleteArea} />
                  {
                    show_delete_response_btn && (
                      <button className='delete-response-btn' onClick={this.handleClickDeleteButton}>
                        이 리스폰스 삭제
                      </button>
                    )
                  }
                </Tab>
              </div>
              <div class="content-col" style={{paddingLeft: 10, paddingRight: 10}}>
                {
                  show_tab_settings && (
                    <Tab title="설정">
                      <ConditionListContainer {...conditionListProps}/>
                      {/* <div class="condition-wrap">
                        <div class="condition">
                          Condition 1
                        </div>
                        <div class="condition">
                          Condition 2
                        </div>
                      </div> */}
                      <div style={{display:'block', height: 40}}>
                        <button class="custom-btn light-btn" style={{marginTop: 10, float: 'left'}}> 
                          리다이렉트 설정
                        </button>
                      </div>
                    </Tab>
                  )
                }
                <Tab title="메시지">
                  <MessageBoardContainer
                    currentEditMessage={messages}
                    isDragging={this.state.isDragging}
                    messageActions={this._messageActions}
                    
                    // editingIndexes={editingIndexes}
                    editing_message_index= {this.state.msgIndex}
                    editing_row_index= {this.state.rowIndex}
                    editing_slide_page_index= {this.state.SPIndex}
                    currentEditSlidePage={currentEditSlidePage}
                  />
                </Tab>
              </div>
              <div class="content-col some-shadow" style={{borderRadius:10}}>
                <ReferenceLists
                  /**
                   * TODO Write Props from container
                   */
                  showTabs={showTabs}
                  topicUpdateID={this.props.topicUpdateID}
                /> 
              </div>
            </div>
          </div>
        </div>
      // </div>
    );
  }
}

export default ResponseManage;